<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :modal="false" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="退款金额：" prop="money">
                <el-input v-model="model.money"></el-input>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'

export default {
    name: 'OrderPartRefound',
    mixins: [editutil],
    data() {
        return {
            model: {
                money: '',
                remark: '',
            },
            getObj:{
                url:'/api/admin/order/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
            rules: {
                money: [
                    {required: true, message: '退款金额不能为空', trigger: 'blur'},
                    {validator: this.validDouble, trigger: 'blur' }
                ],
                remark: [
                    {required: true, message: '备注不能为空', trigger: 'blur'}
                ],
            }
        };
    },
    methods: {
        //保存方法
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.$confirm('确定要退款吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$emit("on-save-ok",{'money': this.model.money, 'remark': this.model.remark});
                    }).catch(() => { })
                }
            })
        },
    }
};
</script>